import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";

@Component({
  selector: 'app-payments-invoices',
  templateUrl: './payments-invoices.component.html',
  styleUrls: ['./payments-invoices.component.sass']
})
export class PaymentsInvoicesComponent implements OnInit, OnDestroy {
  loadObserver: Subscription;
  public paperless = false;
  public empleados = [];
  public cycleDateField: string;
  public diasciclo;
  public banlist = [];
  public balance;
  public updates = 0;
  public billDateField;
  public billDueDateField;
  public billBalanceField;
  public daysleftcycle;
  public amountPayable;
  public slideScreen;
  public dopaymentmount;
  public amountPayable2;
  public email;
  public newEmail;
  public number1;
  public number2;
  public firstload;
  public currentBan: string;
  public loadingData = [];
  public statusPdf: boolean = false;
  public actualPdf: string;
  public ano;
  public cr = '';
  public billDate;
  public invoiceContent;
  public testPrice = 100;
  initialize: Subscription;
  constructor(private services: Service, private loadingScreenService: LoadingScreenService, private global: GlobalService) { }

  ngOnInit() {
    let fecha = new Date();
    this.ano = fecha.getFullYear();
    if (this.global.sessionReview() == true) {
      this.initialize = this.global.initialize.subscribe((value: number) => {
        //actualmente se ejecuta despues del pago
        this.global.refreshDataTo(sessionStorage.getItem("token"), this.currentBan, this.global.getSuscriberByDefault(this.currentBan), false);
        this.banlist = JSON.parse(atob(sessionStorage.getItem("getAcoout"))).accounts.AccountList;
        this.currentBan = this.banlist[0].account;
        for (var i = 0; i < this.banlist.length; i++) {
          this.loadingData[i] = false;
        }
        this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
        this.billDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDateField;
        this.billDueDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;
        this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
        this.daysleftcycle = parseInt(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDaysLeftField);
        this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
        let percentage = this.cycledayspercentage();
        this.paymentAmount();
      });
      this.slideScreen = 0;
      this.banlist = JSON.parse(atob(sessionStorage.getItem("getAcoout"))).accounts.AccountList;
      this.currentBan = this.banlist[0].account;
      for (var i = 0; i < this.banlist.length; i++) {
        this.loadingData[i] = false;
      }
      this.cycleDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDateField;
      this.billDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDateField;
      this.billDueDateField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billDueDateField;
      this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.billBalanceField;
      this.daysleftcycle = parseInt(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.cycleDaysLeftField);
      this.paperless = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
      let percentage = this.cycledayspercentage();
      this.paymentAmount();
      this.loadObserver = this.global.loadObserver.subscribe((data: object) => {
        this.updateUrlPdf(this.currentBan, true);
        let actualAccount = JSON.parse(atob(sessionStorage.getItem("getAccountDetails")));
        this.cycleDateField = actualAccount.AccounInfo.cycleDateField;
        this.billDateField = actualAccount.AccounInfo.billDateField;
        this.billDueDateField = actualAccount.AccounInfo.billDueDateField;
        this.billBalanceField = actualAccount.AccounInfo.billBalanceField;
        this.daysleftcycle = parseInt(actualAccount.AccounInfo.cycleDaysLeftField);
        this.paperless = actualAccount.qualification.RefererResponse.paperless;
        let percentage = this.cycledayspercentage();
        this.paymentAmount();
        this.ngAfterViewInit();
        this.getPersonalData(this.currentBan);
      });
    }
  }
  
  updateUrlPdf(currentBan, sw) {
    if (sessionStorage.getItem("actualPdf") == null || sessionStorage.getItem("actualPdf") == '' || sessionStorage.getItem("actualPdf") == undefined || sw == true) {
      this.statusPdf = false;

      this.services.downloadLastPdf(currentBan, this.ano, "pdf", sessionStorage.getItem("token")).subscribe((data: any) => {
        if (data.HasError == false) {
          this.statusPdf = true;
          sessionStorage.setItem("actualPdf", data.UrlPDF);
          sessionStorage.setItem("BillDateDonwload", data.BillDate);
          sessionStorage.setItem("invoiceContentDonwload", data.invoiceContent);
          this.actualPdf = data.UrlPDF;
          this.billDate = data.BillDate;
          this.invoiceContent = data.invoiceContent;
        }
        else {
          //  this.global.notif(data.ErrorDesc)
        }
      });
    }
    else {
      this.statusPdf = true;
      this.actualPdf = sessionStorage.getItem("actualPdf");
      this.billDate = sessionStorage.getItem("BillDateDonwload");;
      this.invoiceContent = sessionStorage.getItem("invoiceContentDonwload");;
    }
  }

  paymentAmount() {
    if (this.billBalanceField.search('CR') > -1) {
      this.cr = 'CR';
      this.billBalanceField=this.billBalanceField.replace(new RegExp(",","g") ,"");
      this.amountPayable2 = parseFloat(this.billBalanceField).toLocaleString('en-US',{style:'currency', currency:'USD'})+ this.cr;
    }
    else {
      this.cr = '';
      this.billBalanceField=this.billBalanceField.replace(new RegExp(",","g") ,"");
      this.amountPayable = this.billBalanceField;
      this.amountPayable2 = parseFloat(this.amountPayable).toLocaleString('en-US',{style:'currency', currency:'USD'});
    }
    this.checkAmount();
  }
  checkAmount() {
    this.amountPayable=this.amountPayable2.replace( '$','');
    if(this.amountPayable[0]==0){
      this.amountPayable=this.amountPayable.replace("0","");
    }
    this.amountPayable = this.amountPayable.replace(new RegExp(",","g") ,"");
    if (parseFloat(this.amountPayable) >= 5 && parseFloat(this.amountPayable) <= 99999.99) {
      this.dopaymentmount = true;
    }
    else {
      this.dopaymentmount = false;
    }
  }
  cycledayspercentage() {
    if (this.daysleftcycle == null || this.daysleftcycle == undefined || this.daysleftcycle == '') {
      this.daysleftcycle = 0;
    }
    let cycledaysleft = this.daysleftcycle;
    let dias;
    if (cycledaysleft === 1) {
      dias = cycledaysleft + ' día';
    } else {
      dias = cycledaysleft + ' días';
    }
    this.diasciclo = dias;
    let hoy = new Date();
    let diasMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0).getDate();
    let porcConsumido;
    let porcRestante;
    if (cycledaysleft <= 0) {
      porcRestante = 31;
      porcConsumido = 0;
      this.diasciclo = "0 DÍAS";
    }
    else {
      porcRestante = 100 - Math.round((100 * cycledaysleft) / diasMes);
      porcConsumido = Math.round((100 * cycledaysleft) / diasMes);
    }
    return porcRestante;
  }
  ngAfterViewInit() {
    this.global.pid2D(document.getElementById("idCanvas_" + this.slideScreen), this.cycledayspercentage());
  }
  log(event: number) {
    this.currentBan = this.banlist[event].account;
    this.global.validateSession();
    this.slideScreen = event;
    sessionStorage.setItem("selectBan", btoa(this.banlist[event].account));
    if (this.updates == 0) {
      this.updates = 1;
      this.updateUrlPdf(this.currentBan, false);
    }
    else {
      this.currentBan = this.banlist[event].account;
      this.loadingScreenService.startLoadingMin();
      this.global.refreshDataTo(sessionStorage.getItem("token"), this.banlist[event].account, this.banlist[event].subsriberByDefault, false);
    }
  }
  getPersonalData(account) {
    this.services.getPersonalData(sessionStorage.getItem("token"), account).subscribe(data => {
      if (data.HasError == false || data.HasError == true) {
        this.loadingScreenService.stopLoadingMin();
        sessionStorage.setItem("GetPersonalData", btoa(JSON.stringify(data)));
        this.email = data.Email;
        this.newEmail = '';
      }
      else {
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  doPayment() {
    let typeMessage = 'payment';
    this.global.validateSession();
    let mount = this.amountPayable;
    this.global.newPayment(1, typeMessage, atob(sessionStorage.getItem("selectBan")), atob(sessionStorage.getItem("defaultSubscriber")), mount, atob(sessionStorage.getItem("email")), atob(sessionStorage.getItem("companyName")), "", sessionStorage.getItem("token"));
  }
  
  ngOnDestroy() {
    // this.loadObserver.unsubscribe() ;
  }
}